import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Fade from '@material-ui/core/Fade';
import SignupComponent from 'components/account/SignupComponent';
import { PageHeading, Email } from 'components/styled-components/common';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import Signup from 'routes/auth/signup';
import { RootState } from 'StoreModel';
import { connect } from 'react-redux';

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  width: 100%;
  justify-content: flex-end;
`;

const StyledModalContentContainer = styled.div<StyledModalContentContainerProps>`
  width: ${props => {
    if (props.signUpViaEmail) {
      return props.accountConfirmation ? '60% !important' : '30% !important';
    }
    return '23% !important';
  }};
`;

interface StyledModalContentContainerProps {
  signUpViaEmail: boolean;
  accountConfirmation: boolean;
}

interface HeaderContainerProps {
  accountConfirmation: boolean;
}

interface Props extends ReturnType<typeof mapStateToProps> {
  open: boolean;
  onClose: () => void;
  existingUserAction: () => void;
}

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 2, 4),
    width: '23%',
    minWidth: '320px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderRadius: '10px',
  },
}));

const HeaderContainer = styled.div<HeaderContainerProps>`
  display: flex;
  justify-content: ${props => {
    if (props.accountConfirmation) return 'flex-end';
    return 'space-between';
  }};
  width: 100%;
  margin-bottom: 12px;
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;

  padding: 24px 0 0;

  text-align: left;

  > span {
    font-weight: 500;
    font-size: 14px;
  }
`;

const SignupLabel = styled(PageHeading)`
  text-transform: none;
  width: 80%;
  margin-top: 0.5em;
  font-size: 1.3rem;
  font-weight: 600;
`;

const mapStateToProps = (state: RootState) => ({
  literals: state.literals,
  bearer: state.account.session.session.bearer,
});

const SignupModal: React.FC<Props> = ({ open, onClose, existingUserAction, literals, bearer }) => {
  const classes = useStyles();
  const [signUpViaEmail, setSignUpViaEmail] = useState<boolean>(false);
  const [accountConfirmation, setAccountConfirmation] = useState<boolean>(false);

  useEffect(() => {
    if (bearer) {
      onClose();
    }
  }, [bearer]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <StyledModalContentContainer
          className={classes.paper}
          signUpViaEmail={signUpViaEmail}
          accountConfirmation={accountConfirmation}
        >
          <>
            <HeaderContainer accountConfirmation={accountConfirmation}>
              {!accountConfirmation && (
                <SignupLabel>{literals.create_account_for_application_heading_label}</SignupLabel>
              )}
              <StyledCloseIcon onClick={onClose} fontSize="large" />
            </HeaderContainer>
            {signUpViaEmail ? (
              <Signup insideModal setAccountConfirmation={setAccountConfirmation} />
            ) : (
              <SignupComponent setSignUpViaEmail={() => setSignUpViaEmail(true)} />
            )}
            {!accountConfirmation && (
              <FooterContainer>
                <span>{literals.public_signup_already_have_an_account}</span>

                <Email onClick={existingUserAction}>
                  <MailOutlineIcon />
                  <span>{literals.log_on_log_in_title}</span>
                </Email>
              </FooterContainer>
            )}
          </>
        </StyledModalContentContainer>
      </Fade>
    </Modal>
  );
};

export default connect(mapStateToProps, {})(SignupModal);
